import React, { useEffect, useState } from "react";
import { TextField, Button, Box, Typography, InputAdornment, Snackbar, Alert } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import anmolLogo from "../../assets/images/anmol_logo_transparent.png";
import CoverLayout from "layouts/newVendor/vendorRegistration/components/CoverLayout";
import { useNavigate } from "react-router-dom";
import "../style.css"
import { ToastContainer, toast } from "react-toastify";
import SoftSelect from "components/SoftSelect";
import Select from "react-select"
import { validateEmailMobile } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { authenticateVendor } from "assets/globalAPI/apiGlobal";

const CustomerValidationFinal = () => {
  const toastId = React.useRef(null);
  const navigate= useNavigate();
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [otpMobile, setOtpMobile] = useState("");
  const [otpEmail, setOtpEmail] = useState("");
  const [otpEnabledMobile, setOtpEnabledMobile] = useState(false);
  const [otpEnabledEmail, setOtpEnabledEmail] = useState(false);
  const [otpVerifiedMobile, setOtpVerifiedMobile] = useState(false);
  const [otpVerifiedEmail, setOtpVerifiedEmail] = useState(false);
  const [otpEnabled, setOtpEnabled] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [otpSentMobile, setOtpSentMobile] = useState(false);
  const [otpSentEmail, setOtpSentEmail] = useState(false);
  const [isActive, setIsActive] = useState(false);
   const [alphahash, setAlphahash] = useState("");
    const [userg, setUserg] = useState("");
    const [alpha, setAlpha] = useState("");
    const [beta, setBeta] = useState("");
    const [gamma, setGamma] = useState("");


  useEffect(()=>{
    const vendorEmail= localStorage.getItem("customerEmail");
    const vendorPhone= localStorage.getItem("customerMobile");
    setEmail(vendorEmail);
    setMobile(vendorPhone);
  },[])

  useEffect(()=>{
      const queryParams = new URLSearchParams(location.search);
      const decodeBase64 = (encoded) => {
        if (!encoded) return "";
        
        try {
          const base64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
          const binaryString = window.atob(base64);
          console.log("binary string>> ", binaryString)
          const bytes = new Uint8Array([...binaryString].map((char) => char.charCodeAt(0)));
          return new TextDecoder().decode(bytes); // Decode properly
        } catch (error) {
          console.error("Base64 decoding failed:", error);
          return "";
        }
      };
  
      // console.log("the alpha>> ", queryParams.get("aplhahash") || "");
  
      setAlphahash(decodeBase64(queryParams.get("aplhahash") || ""));
      setUserg(decodeBase64(queryParams.get("userg") || ""));
      setAlpha(decodeBase64(queryParams.get("alpha") || ""));
      setBeta(decodeBase64(queryParams.get("beta") || ""));
      setGamma(decodeBase64(queryParams.get("gamma") || ""));
    },[location.search])

  const handleGetOtpForMobile = () => {
    if ( mobile.length === 10) {
        if (!toast.isActive(toastId.current)){
            toastId.current= toast.success("Please enter OTP sent to mobile number",{
              className: "small-toast"
            } );
          }
      setOtpEnabledMobile(true);
      setOtpSentMobile(true);
     
    } else {
      if (!toast.isActive(toastId.current)){
        toastId.current= toast.warning("Please enter a valid 10-digit mobile number",{
          className: "small-toast"
        } );
      };
    }
  };

  const handleGetOtpForEmail = () => {
    if ( email!==""&& email) {
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.success("Please enter OTP sent to email address",{
            className: "small-toast"
          } );
        }
        setOtpEnabledEmail(true);
        setOtpSentEmail(true);
    } else {
      if (!toast.isActive(toastId.current)){
        toastId.current= toast.warning("Please enter valid email address",{
          className: "small-toast"
        } );
      }
    }
  };

  // const handleVerifyOtpEmail = () => {
  //   if (otpEmail === "123456") { // Mock OTP verification
  //     setOtpVerifiedEmail(true);
  //     alert("OTP Verified Successfully!"); // Mock success message
  //   } else {
  //     alert("Invalid OTP. Please try again.");
  //   }
  // };

  // const handleVerifyOtpMobile = () => {
  //   if (otpMobile === "123456") { // Mock OTP verification
  //     setOtpVerifiedMobile(true);
  //     alert("OTP Verified Successfully!"); // Mock success message
  //   } else {
  //     alert("Invalid OTP. Please try again.");
  //   }
  // };

  const handleCaptchaChange = (token) => {
    setCaptchaValue(token);
  };

  const handleGetOtp=async()=>{
      setIsActive(true)
      
   
       
        const body={
          usertype: "customer",
          type: gamma,
          anmoluser: userg,
          anmolemail: alpha,
          anmolmobile: beta,
          anmoluserhash: alphahash
        }
        try{
          const response= await validateEmailMobile(body);
          const res= response.data;
          console.log("receieved validation otp>> ", res);
          if(res.status){
            if (!toast.isActive(toastId.current)){
              toastId.current= toast.success("Please enter otp sent to email and mobile",{
                className: "small-toast"
              } );
            }
            setIsActive(false)
            setOtpEnabledEmail(true);
          setOtpSentEmail(true);
          setOtpEnabled(true)
          }else{
            if (!toast.isActive(toastId.current)){
              toastId.current= toast.warning("Could not send OTP",{
                className: "small-toast"
              } );
            }
            setIsActive(false)
            console.log("the res>> ", res);
            return;
          }
        }catch(err){
          console.log("Error sending OTP>> ", err);
          if (!toast.isActive(toastId.current)){
            toastId.current= toast.error("Error Sending OTP",{
              className: "small-toast"
            } );
          }
          setIsActive(false)
        }
        console.log("otp sent to>> ", body)
        
    }

  const registerVendor=async()=>{
      setIsActive(true)
      const body={
        "usertype":"customer",
        "type": gamma,
   "anmoluser":userg,
   "anmolemail":alpha,
   "anmolmobile":beta,
   "emailOTP":otpEmail,
   "mobileOTP":otpMobile,
   "anmoluserhash":alphahash
      }
      console.log("the body>> ", body)
  
      if(otpMobile==="" || otpEmail===""){
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.warning("Please Enter OTP",{
            className: "small-toast"
          } );
        }
        return;
      }
  
      try{
        const response= await authenticateVendor(body);
        const res= response.data;
        console.log("the response of authenticate>> ", res);
        if(res.status){
          if (!toast.isActive(toastId.current)){
            toastId.current= toast.success(res.message,{
              className: "small-toast"
            } );
          }
          setIsActive(false)
          localStorage.setItem("contactPersonEmail", alpha);
          localStorage.setItem("contactPersonMobile", beta);
          localStorage.setItem("isAuthenticated", true);
          localStorage.setItem("refId", res.userid);
          localStorage.setItem("customer_type", gamma);
          localStorage.setItem("refType", res.usertype)
          localStorage.setItem("authToken", res.token)
          localStorage.setItem("userToken", res.token)
          localStorage.removeItem("isRegistered");
          setTimeout(()=>{
            navigate("/customer/customer-type")
          }, 1000)
        }else{
          if (!toast.isActive(toastId.current)){
            toastId.current= toast.error(res.message,{
              className: "small-toast"
            } );
          }
          setIsActive(false)
          return;
        }
  
      }catch(err){
        console.log("Error in authenticate>> ", err);
        if (!toast.isActive(toastId.current)){
          toastId.current= toast.error(err.message,{
            className: "small-toast"
          } );
        }
        setIsActive(false)
      }
      
    }

  return (
    
<>
<ToastContainer/>
<SimpleBackdrop openLoader={isActive}/>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
        padding: "20px",
      }}
    >

<Box
    sx={{
      width: "600px",
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
    }}
  >
    <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
      <img
        src={anmolLogo}
        alt="Anmol Industries Limited"
        style={{ width: "60px", height: "auto" }}
      />
    </Box>

    <Typography variant="h5" fontWeight="bold" align="center" gutterBottom>
      Customer Registration
    </Typography>

    {/* Email & Mobile Input Fields */}
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Vendor Email */}
      <Box display="flex" flexDirection="column">
        <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
          Customer Contact Email
        </Typography>
        <TextField
          fullWidth
          className="input-email-vendor"
          variant="outlined"
          placeholder="Enter your email ID"
          value={alpha}
          disabled
          sx={{ width: "100%" }}
        />
      </Box>

      {/* Vendor Mobile */}
      <Box display="flex" flexDirection="column">
        <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
          Customer Contact Number
        </Typography>
        <TextField
          fullWidth
          type="number"
          variant="outlined"
          placeholder="Enter Mobile No."
          value={beta}
          disabled
          sx={{ width: "100%" }}
        />
      </Box>

      {/* Single Get OTP Button */}
      <Button
        variant="contained"
        color="primary"
        sx={{ color: "ivory", whiteSpace: "nowrap", mt: 1 }}
        onClick={handleGetOtp}
      >
        Get OTP
      </Button>
    </Box>

    {/* OTP Inputs - Shown when button is clicked */}
    {otpEnabled && (
      <Box display="flex" justifyContent="space-between" gap={2} mt={2}>
        {/* Email OTP */}
        <Box display="flex" flexDirection="column" width="50%">
          <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
            Enter OTP (Email)
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Enter valid OTP"
            value={otpEmail}
            onChange={(e) => setOtpEmail(e.target.value)}
          />
        </Box>

        {/* Mobile OTP */}
        <Box display="flex" flexDirection="column" width="50%">
          <Typography fontSize="17px" fontFamily="serif" fontWeight="medium">
            Enter OTP (Mobile)
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Enter valid OTP"
            value={otpMobile}
            onChange={(e) => setOtpMobile(e.target.value)}
          />
        </Box>
      </Box>
    )}

    {/* CAPTCHA (Shown when OTP fields appear) */}
    {otpEnabled && (
      <Box display="flex" flexDirection="column" alignItems="center" sx={{ mt: 2, mb: 1 }}>
        <Typography align="center" fontSize="17px" fontWeight="medium" sx={{ mb: 1 }}>
          Complete Captcha
        </Typography>
        <ReCAPTCHA
          sitekey="6LcqVcwqAAAAAPtKBhaUCVJUEIriLUATiYxwA4Uv"
          onChange={handleCaptchaChange}
        />
      </Box>
    )}

    {/* Submit Button */}
    <Button
      fullWidth
      variant="contained"
      color="success"
      sx={{
        mt: 3,
        backgroundColor: "#28a745",
        color: "ivory",
        "&:hover": {
          backgroundColor: "#28a745",
          color: "ivory",
        },
      }}
      disabled={!captchaValue}
      onClick={registerVendor}
    >
      Submit
    </Button>
  </Box>
    </Box>
</>

  );
};

export default CustomerValidationFinal;
